import { Component } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../Services/auth.service';
import { ApiService } from '../Services/api.service';
import { CommonModule } from '@angular/common';
import { ToastService } from '../Services/toast.service';

@Component({
  selector: 'app-update-password',
  standalone: true,
  imports: [InputTextModule, PasswordModule, FormsModule, ButtonModule, TranslateModule, CommonModule],
  providers: [AuthService, ApiService, ToastService, TranslateService],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.css'
})
export class UpdatePasswordComponent {
  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  providerId: string;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private apiService: ApiService<any>,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.providerId = this.authService.getCurrentUserPID();
  }

  updatePassword(form: NgForm) {
    if (form.invalid || this.newPassword !== this.confirmPassword) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      this.translateService.get('toast.fillinallthefields').subscribe(text => this.toastService.showError(text));
      return;
    }
    const updateData = {
      providerId: this.providerId,
      oldPassword: this.oldPassword,
      newPassword: this.newPassword
    };
    this.apiService.create('api/User/update-password', updateData).subscribe({
      next: (response: any) => {
        if (response?.isRequestSuccessful === true) {
          this.translateService.get('toast.passwordupdatedsuccessfully').subscribe(text => this.toastService.showSuccess(text));

          form.resetForm();
        } else {
          this.toastService.showError(response?.errorDetail?.errorReason || "Error updating password");
        }
      },
      error: (err) => {
        this.toastService.showError(err);
      }
    });
  }

}
